import { ReactComponent as AddSheetIcon } from "../assets/icons/add-sheet.svg"
import { ReactComponent as AddSheet2Icon } from "../assets/icons/add-sheet-2.0.svg"
import { ReactComponent as FlowchartChoiceIcon } from "../assets/icons/flowchart-choice.svg"
import { ReactComponent as AutogenerateCanvasIcon } from "../assets/icons/autogenerate-canvas.svg"
import { UISheetType } from "../types/UITypes"
import { Dispatch, useMemo } from "react"

type ToolBarProps = {
  handleAddConditionBlock: () => void
  handleAddSheet: (annotationType: UISheetType) => void
  isLLMUsageExceeded: boolean
  setAutogenerateResult: Dispatch<any>
  setAutogenerateDialogOpen: Dispatch<boolean>
  userType: "Dev" | "PMBiz" | "Superuser"
  setUserType: Dispatch<"Dev" | "PMBiz" | "Superuser">
  enabledFeatures?: string[]
}

export const ToolBar = (props: ToolBarProps) => {
  const {
    handleAddConditionBlock,
    handleAddSheet,
    isLLMUsageExceeded,
    setAutogenerateResult,
    setAutogenerateDialogOpen,
    userType,
    setUserType: setUserRole,
    enabledFeatures = [],
  } = props

  const isMatrixEnabled = useMemo(
    () => enabledFeatures.includes("matrix"),
    [enabledFeatures]
  )

  const isFlowchartEnabled = useMemo(
    () => enabledFeatures.includes("flowchart"),
    [enabledFeatures]
  )

  return (
    <div className="tools-container">
      {isFlowchartEnabled && (
        <button
          className="tool-button canvas-toolbar-button"
          onClick={handleAddConditionBlock}
        >
          <FlowchartChoiceIcon />
          FlowChart Choice
        </button>
      )}

      <div className="tool-separator"></div>
      <button
        className="tool-button canvas-toolbar-button"
        onClick={() => handleAddSheet(UISheetType.SHEET)}
      >
        <AddSheetIcon />
        Sheet
      </button>

      <div className="tool-separator"></div>

      {isMatrixEnabled && (
        <button
          className="tool-button canvas-toolbar-button"
          onClick={() => handleAddSheet(UISheetType.MATRIX)}
        >
          <AddSheet2Icon />
          Matrix
        </button>
      )}

      <div className="tool-separator"></div>

      <button
        title={isLLMUsageExceeded ? "Limit reached" : undefined}
        className="tool-button canvas-toolbar-button"
        disabled={isLLMUsageExceeded}
        onClick={() => {
          setAutogenerateResult(undefined)
          setAutogenerateDialogOpen(true)
        }}
      >
        <AutogenerateCanvasIcon />
        Autogenerate
      </button>
    </div>
  )
}
